import { StoredAuthorization, useAuth, useInitializeOfflineData } from "duck";
import {
  GetOrganizationSettingsDocument,
  useRemoveAuthorizationSettingsMutation
} from "requests";

export const useDeleteAuthorizationSettings = (
  auths: StoredAuthorization[],
  onSuccess: () => void
) => {
  const [remove] = useRemoveAuthorizationSettingsMutation({
    ignoreResults: true
  });
  const [{ user }] = useAuth();
  const { loadDisclaimers } = useInitializeOfflineData();

  return () =>
    remove({
      variables: { input: { ids: auths.map(auth => auth._id) } },
      refetchQueries: [GetOrganizationSettingsDocument]
    }).then(() => {
      onSuccess();
      loadDisclaimers(user.organization?._id || 0);
    });
};
